// src/cert/iso22301.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const ISO22301 = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>ISO 22301 प्रमाणन</h1>
                <p>व्यवसाय सातत्य व्यवस्थापन प्रणाली (Business Continuity Management System)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>ISO 22301 म्हणजे काय?</h2>
                    <p>

                        ISO 22301 is an international standard that provides a framework for business continuity. This ISO 22301 training helps delegates to get in-depth knowledge of methods, requirements, and benefits of using a Business Continuity Management System (BCMS) within their organisations. It enables you to minimise business disruption and how to effectively maintain continuity of business operations in their organisations. ISO 22301 standard will be taught by our highly experienced instructor, which will help you to pass your exam in the very 1st attempt.

                        We deliver training solutions to corporate, government agencies, public sectors, multinational organisations and private individuals. Our subject matter experts have plentiful industry knowledge, who know how to make their topics engaging to create a memorable and valuable learning environment. Our dedicated staff work incessantly to provide in-house training to clients that wish to have the convenience and comfort of working within their familiar surroundings.

                        The Knowledge Academy is Globally Recognised as the Industry Leader in training Business Continuity Management (BCM). Our Business Continuity Management (BCM) Expert Team comprises of over 21 leading BCM Professionals who on average have more than 11 years of ISO 22301 Industry Experience. Our instructors have developed a unique teaching style to help an aspiring candidate to master the art of successfully plan, establish, implement and maintain business continuity in your organisation.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>संकटातही सेवा/उत्पादन सुरू राहते</li>
                        <li>आर्थिक नुकसान कमी होते</li>
                        <li>ग्राहकांचा विश्वास टिकतो</li>
                        <li>कायदेशीर आणि नियामक अनुपालन</li>
                        <li>जोखीम मूल्यांकन आणि प्रतिसाद योजना तयार होते</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>ISO 22301 साठी अर्ज करा</h2>
                    <ApplyForm certification="ISO 22301" />
                </section>
            </div>
        </div>
    );
};

export default ISO22301;